<template>
  <div class="row">
    <div class="col-12">
      <div class="card p-2">
        <div class="card-body">
          <div class="row align-items-center mb-2" v-if="!noTitle">
            <div class="col">
              <label class="font-weight-bold d-inline mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-hard-drive icon-dual icon-xs mr-2"><line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line></svg>
              {{ title }}: </label>
            </div>
          </div>
          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <div class="dataTables_length">
                <label class="d-inline-flex align-items-center dataTable_entries">
                  <span >{{$t('common.show')}}</span>
                  <b-form-select
                    v-model="perPage"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                  <span >{{$t('common.entries')}}</span>
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-right"
              >
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                    @keydown.enter.native="filterList"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :show-empty="true"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              @sort-changed="sortChange"
            >
              <template v-slot:cell(radio)="row">
                <td>
                  <input
                    :key="row.item._id"
                    class="mx-1 mb-1"
                    type="radio" 
                    v-model="row.item.default"
                    @input="$emit('radioClicked', row.item._id)"
                    :value="true"
                  />
                </td>
              </template>
              <template v-slot:cell(actions)="row">
                <div class="d-flex justify-content-end">
                  <button class="btn2 btn2-primary btn-sm mx-1 mb-1" @click="$emit('openFormBar', row.item._id)" v-if="useView">
                    <i class="uil uil-eye"></i>
                  </button>

                  <button class="btn2 btn2-primary btn-sm mx-1 mb-1" @click="$emit('openFormBar', row.item._id, true)" v-if="useEdit">
                    <i class="uil uil-edit"></i>
                  </button>

                  <button class="btn2 btn2-danger btn-sm mx-1 mb-1" @click="$emit('openFormBar', row.item._id, false, true)" v-if="useDelete">
                    <i class="uil uil-trash-alt"></i>
                  </button>

                </div>
              </template>

            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => {}
    },
    noTitle: {
      type: Boolean,
      default: false
    },
    useView: {
      type: Boolean,
      default: false
    },
    useEdit: {
      type: Boolean,
      default: false
    },
    useDelete: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: () => []
    },
    action: String,
    sort: String
  },
  data() {
		return {
			items: [],
			totalRows: 0,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
      filter: null,
			filterOn: [],
			sortBy: this.sort || 'date_created',
			sortDesc: true,
      isBusy:false,
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData(){
      if(this.action){
        this.toggleBusy();
        try {
          const res = await this.$store.dispatch(this.action, this.params);
          if (res && res.data) {
            this.items = res.data.data ? res.data.data : res.data;
            // Update total rows for pagination
            this.totalRows = res.data.total || this.items.length;
          }
        } catch (error) {
          console.error('Error fetching data:', error);
        } finally {
          this.toggleBusy();
        }
      }
    },
    sortChange(sortValue){
      this.sortBy = sortValue.sortBy
      this.sortDesc = sortValue.sortDesc
      this.fetchData().catch(error => {
        console.error(error)
      })
    },
    onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    filterList(){
      this.fetchData()
      .catch(error => {
        console.error(error)
      })
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    // Monitor items changes to update totalRows
    items: {
      handler: function(newItems) {
        if (!this.totalRows || this.totalRows === 0) {
          this.totalRows = newItems.length;
        }
      },
      deep: true
    }
  },
}
</script>

<style>

</style>